import {$, Helper, Request, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {NotasInseridasCollection} from '@/model/collection/NotasInseridasCollection'
import {QtdNotasMes} from '@/model/resource/QtdNotasMes'

export class NotasInseridas extends Resource {
  idNotasInseridasPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  qtdNotas: number | null = null

  dataProcessada: string | null = null

  @ResponseSerialize(QtdNotasMes)
  qtdNotasMes: QtdNotasMes[] | null = null

  qtdNotasSemanas: number[] | null = null

  get $id() {
    return this.idNotasInseridasPk
  }
  set $id(val) {
    this.idNotasInseridasPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  static async listNotasInseridasMonthly(params: any) {
    return await Request.get(`/admin/notas-inseridas/monthly`, {params})
      .name('listNotasInseridasMonthly')
      .as(NotasInseridasCollection)
      .getData()
  }

  static async listNotasInseridasWeekly(params: any) {
    return await Request.get(`/admin/notas-inseridas/weekly`, {params})
      .name('listNotasInseridasWeekly')
      .as(NotasInseridasCollection)
      .getData()
  }

  static async listAvailableYears() {
    return await Request.get(`/admin/notas-inseridas/get-available-years`)
      .name('listAvailableYears')
      .asArrayOf(String)
      .getData()
  }

  static async getLastGenerationDate() {
    return await Request.get(`/admin/notas-inseridas/get-last-generation-date`)
      .name('getLastGenerationDate')
      .asString()
      .getData()
  }
}
